<cd-server-not-responding></cd-server-not-responding>

<div
  class="wrapper"
>
  <div class="content">
    <cd-header></cd-header>

    <div class="main">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer></app-footer>
</div>
